import PropTypes from 'prop-types';

import { MEDIA_TYPES } from '@/common/constants';
import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const SliderMediaDefaultProps = {
  ...BaseDefaultProps,
  ...ClassNameDefaultProps,
  flags: [],
  getImageAlt: () => null,
  getImageSrc: () => null,
  handleClickItem: () => null,
  handleCloseModal: () => null,
  isOpenModal: false,
  slider: [],
  sliderModalSettings: {},
  sliderSettings: {},
  tag: null,
};

export const SliderMediaPropTypes = {
  ...BasePropTypes,
  ...ClassNamePropTypes,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  getImageAlt: PropTypes.func,
  getImageSrc: PropTypes.func,
  handleClickItem: PropTypes.func,
  handleCloseModal: PropTypes.func,
  id: PropTypes.string.isRequired,
  isOpenModal: PropTypes.bool,
  slider: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      path: PropTypes.string,
      type: PropTypes.oneOf([MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO]),
      url: PropTypes.string,
    }),
  ),
  sliderModalSettings: PropTypes.shape({}),
  sliderSettings: PropTypes.shape({}),
  tag: PropTypes.string,
};
